// src/utils/machineCapacity.js
//
// WHY THIS FILE EXISTS:
// Site machines are rated in different units depending on the equipment:
//   - Split / Cassette / Ducted AC  -> TR (Ton)
//   - VRV / VRF outdoor units       -> HP (manufacturer's nominal rating)
//   - Chillers / some VRF sheets    -> kW
// Capacity is stored EXACTLY as written on the nameplate: a value plus its unit.
//
// We NEVER auto-convert between units. HP on a VRV unit is a model rating,
// not a precise physical conversion, so a converted TR figure would be a guess
// stored as if it were fact.
//
// LEGACY: machines saved before this change only have `capacity_tr` and no
// `capacity_unit`. They are read as TR (detect-and-fallback, no data migration).
// This is the single place that decides how capacity is displayed — every
// screen showing a machine's capacity must use formatMachineCapacity().

export const CAPACITY_UNITS = [
  { value: "TR", label: "TR (Ton)" },
  { value: "HP", label: "HP" },
  { value: "kW", label: "kW" },
];

// Unit a machine type is normally rated in. Only a pre-selection —
// the user can always change it on the form.
const DEFAULT_UNIT_BY_TYPE = {
  VRF: "HP",
};

export function defaultCapacityUnitForType(machineType) {
  return DEFAULT_UNIT_BY_TYPE[machineType] || "TR";
}

export function formatMachineCapacity(machine) {
  if (!machine) return "—";

  const value = machine.capacity_value;
  const hasNewSchema = value !== undefined && value !== null && value !== "";

  if (hasNewSchema) {
    const unit = CAPACITY_UNITS.find(u => u.value === machine.capacity_unit);
    // Short unit code for display ("TR", "HP", "kW"), not the dropdown label
    return `${value} ${unit ? unit.value : "TR"}`;
  }

  // Legacy machine (saved before capacity_unit existed) — always TR
  if (machine.capacity_tr) return `${machine.capacity_tr} TR`;

  return "—";
}